import * as _ from 'lodash'
import React, { useState } from 'react';
import componentServices from '../componentServices';
import { useJobCostItemDragDrop } from '../draggableJobCostLineItem';
import valueFilters from '../valueFilters';
import util from '../util';
import enums from '../enum';
import { getModel, ModelCollection } from '../store';

import { CurrencyInput, Header, jobCostRowOwner, JobCostHiddenWhenLocked, JobCostLockable, NumericInput } from './sharedComponents';

const _jobCostLineItemTypes = ['client-upgrade', 'builder-upgrade'];

const JobCostUpgradeRow = (props) => {
	const { alwaysValidate, buttonHandler, classNames = [], draggable, buttonClass, dropLineItem, lineItem, updateModel, upgrades, workAreas } = props;
	const [shouldValidate, setShouldValidate] = useState(alwaysValidate);
	const [{isDragging, dragSourceRef, dragPreviewRef, dropItem, dropTargetRef, rowRef}] = useJobCostItemDragDrop({ 
		item: lineItem,
		handleDrop: (dragItem, dropItem) => dropLineItem(dragItem.key, dropItem.key) 
	});

	function handleUpdate (path, autoSave, e) {
		let newVal;
		if (e.target.type === 'checkbox') {
			newVal = e.target.checked;
		}
		else {
			newVal = (autoSave) ? valueFilters.clean(e.target.value) : e.target.value;
		}

		updateModel((model, updateCallback) => {
			if (path === 'unitSell') {
				path = 'sellPrice';
				newVal = Number(newVal || 0) * (model.quantity || 0);
			}
			else if (path === 'quantity') {
				if (!newVal) {
					newVal = 1;
				}

				const unitSell = (model.sellPrice || 0) / (model.quantity || 1);

				model.sellPrice = (unitSell * Number(newVal)).toFixed(2);
			}
			else if (path === 'description') {
				const upgrade = _.find(upgrades, { description: newVal });

				if (upgrade) {
					model.sellPrice = Number(upgrade.sellPrice || 0) * (model.quantity || 0);
				}
			}

			model.setAt(path, newVal);

			updateCallback(model, path);
		}, { autoSave: autoSave });
	}

	function validate (property?) {
		if (!property || shouldValidate) {
			const result = !lineItem.test(property);

			return result;
		}
		return true;
	}

	function handleButtonClick (e) {
		e.preventDefault();

		const valid = validate();

		if (!valid) {
			setShouldValidate(true);
		}
		else {
			// this assumes that the add handler succeeds
			setShouldValidate(alwaysValidate);
		}

		buttonHandler(valid, e);
	}

	let dropClass = null;
	const dragClass = isDragging ? 'disabled' : null;
	const itemOptions = [];

	if (dropItem) {
		const dropIndex = lineItem.sortIndex;
		const dragIndex = dropItem.sortIndex;

		dropClass = (dropIndex > dragIndex) ? 'dropBottom' : 'dropTop';
	}

	const rowClasses = _.concat(classNames, dropClass, dragClass);
	const dragHandle = (draggable) ? <button ref={ dragSourceRef } className="icon iconOnly drag"><span /></button> : null;

	const renderer = {
		render_client_upgrade () { // eslint-disable-line camelcase
		// Define the work area options list
			const workAreaOptions = [];

			workAreaOptions.push(<option key="unknown" value="">Select</option>);
			_.forEach(workAreas, workArea => {
				workAreaOptions.push(<option key={workArea.key} value={workArea.key}>{workArea.name}</option>);
			});

			const unitSell = (lineItem.sellPrice || 0) / (lineItem.quantity);

			_.forEach(upgrades, upgrade => {
				itemOptions.push(<option key={upgrade.key}>{upgrade.description}</option>);
			});

			return <tr ref={ rowRef } className={rowClasses.join(' ')}>
				<td />
				<td>{dragHandle}</td>
				<td className={(!validate('workAreaKey') ? 'required' : '')}>
					<select className="select" placeholder="Select" value={lineItem.viewValue('workAreaKey')} onChange={e => handleUpdate('workAreaKey', true, e)}>
						{ workAreaOptions }
					</select>
				</td>
				<td className={(!validate('description') ? 'required' : '')}>
					<input type="text" className="dataList" list={'item_' + lineItem.key} placeholder="Enter" autoCapitalize="" autoCorrect="off" value={lineItem.viewValue('description')} onChange={e => handleUpdate('description', false, e)} onBlur={e => handleUpdate('description', true, e)} />
					<datalist id={'item_' + lineItem.key}>
						{ itemOptions }
					</datalist>
				</td>
				<td className="cost"><CurrencyInput type="text" placeholder="0" value={ unitSell } onChange={e => handleUpdate('unitSell', false, e)} onBlur={e => handleUpdate('unitSell', true, e)}/></td>
				<td className={'quantity ' + ' ' + (!validate('quantity') ? 'required' : '')}><NumericInput type="text" placeholder="0" min="0" value={lineItem.viewValue('quantity')} onChange={e => handleUpdate('quantity', false, e)} onBlur={e => handleUpdate('quantity', true, e)} /></td>
				<td className="centered"><input type="checkbox" checked={lineItem.isOptional} onChange={e => handleUpdate('isOptional', true, e)} /></td>
				<td className="centered"><input type="checkbox" checked={lineItem.isChargedToBuilder} onChange={e => handleUpdate('isChargedToBuilder', true, e)} /></td>
				<td className="sell"><span className="readOnly">{ util.formatAsCurrency(lineItem.sellPrice) }</span></td>
				<td><button className={buttonClass} onClick={handleButtonClick}><span /></button></td>
				<td />
			</tr>;
		},

		render_builder_upgrade () { // eslint-disable-line camelcase
		// Define the work area options list
			const workAreaOptions = [];

			workAreaOptions.push(<option key="unknown" value="">Select</option>);
			_.forEach(workAreas, workArea => {
				workAreaOptions.push(<option key={workArea.key} value={workArea.key}>{workArea.name}</option>);
			});

			_.forEach(upgrades, upgrade => {
				itemOptions.push(<option key={upgrade.key}>{upgrade.description}</option>);
			});

			return <tr ref={ rowRef } className={rowClasses.join(' ')}>
				<td />
				<td>{dragHandle}</td>
				<td colSpan={4} className={(!validate('workAreaKey') ? 'required' : '')}>
					<select className="select" placeholder="Select" value={lineItem.viewValue('workAreaKey')} onChange={e => handleUpdate('workAreaKey', true, e)}>
						{ workAreaOptions }
					</select>
				</td>
				<td className={(!validate('description') ? 'required' : '')}>
					<input type="text" className="dataList" list={'item_' + lineItem.key} placeholder="Enter" autoCapitalize="" autoCorrect="off" value={lineItem.viewValue('description')} onChange={e => handleUpdate('description', false, e)} onBlur={e => handleUpdate('description', true, e)} />
					<datalist id={'item_' + lineItem.key}>
						{ itemOptions }
					</datalist>
				</td>
				<td className={(!validate('itemNote') ? 'required' : '')}><input type="text" placeholder="Enter" autoCapitalize="" autoCorrect="off" value={lineItem.viewValue('itemNote')} onChange={e => handleUpdate('itemNote', false, e)} onBlur={e => handleUpdate('itemNote', true, e)} /></td>
				<td className="sell"><CurrencyInput type="text" placeholder="0" value={ lineItem.viewValue('sellPrice') } onChange={e => handleUpdate('sellPrice', false, e)} onBlur={e => handleUpdate('sellPrice', true, e)}/></td>
				<td><button className={buttonClass} onClick={handleButtonClick}><span /></button></td>
				<td />
			</tr>;
		}
	}

	return renderer[_.snakeCase('render-' + lineItem.type)]();
}

const JobCostUpgradeHead = ({ type }) => {
	if (type === 'client-upgrade') {
		return (<thead>
			<tr>
				<td />
				<td />
				<td><span className="readOnly">Work Area</span></td>
				<td className="description"><span className="readOnly">Description</span></td>
				<td className="cost"><span className="readOnly">Unit Sell</span></td>
				<td className="quantity"><span className="readOnly">Quantity</span></td>
				<td className="centered"><span className="readOnly">Optional</span></td>
				<td className="centered"><span className="readOnly">Charge To Builder</span></td>
				<td className="cost"><span className="readOnly">Total</span></td>
				<td className="action" />
				<td />
			</tr>
		</thead>);
	}
	else if (type === 'builder-upgrade') {
		return (<thead>
			<tr>
				<td />
				<td />
				<td colSpan={4}><span className="readOnly">Work Area</span></td>
				<td className="description"><span className="readOnly">Description</span></td>
				<td><span className="readOnly">Internal Notes</span></td>
				<td className="cost"><span className="readOnly">Total</span></td>
				<td className="action" />
				<td />
			</tr>
		</thead>);
	}
};

const JobCostUpgradeFoot = ({ jobCost, summary, type }) => {
	if (type === 'client-upgrade') {
		return (<tfoot className="subtotal">
			<tr>
				<td />
				<td className="cost" colSpan={7}>Client Upgrade Subtotal</td>
				<td className="cost" colSpan={1}><span className="readOnly">{ util.formatAsCurrency(summary.clientUpgradeSellPrice) }</span></td>
				<td />
				<td />
			</tr>
			<tr>
				<td />
				<td className="cost" colSpan={7}>GST</td>
				<td className="cost" colSpan={1}><span className="readOnly">{ util.formatAsCurrency(summary.clientUpgradeTaxesAndFees) }</span></td>
				<td />
				<td />
			</tr>
			<tr>
				<td />
				<td className="cost" colSpan={7}>Client Total</td>
				<td className="cost" colSpan={1}><span className="readOnly">{ util.formatAsCurrency(summary.clientUpgradeSellPrice + summary.clientUpgradeTaxesAndFees) }</span></td>
				<td />
				<td />
			</tr>
		</tfoot>);
	}
	else {
		return (<tfoot className="subtotal">
			<tr>
				<td />
				<td className="cost" colSpan={7}>Base Price</td>
				<td className="cost" colSpan={1}><span className="readOnly">{ util.formatAsCurrency(summary.orderSellPrice) }</span></td>
				<td />
				<td />
			</tr>
			<tr>
				<td />
				<td className="cost" colSpan={7}>Builder Discount</td>
				<td className="cost" colSpan={1}><span className="readOnly">{ (jobCost.builderDiscountPercent * 100).toFixed(2) }%</span></td>
				<td />
				<td />
			</tr>
			<tr>
				<td />
				<td className="cost" colSpan={7}>Client Upgrades Charged to Builder</td>
				<td className="cost" colSpan={1}><span className="readOnly">{ util.formatAsCurrency(summary.clientUpgradeChargedToBuilderSellPrice) }</span></td>
				<td />
				<td />
			</tr>
			<tr>
				<td />
				<td className="cost" colSpan={7}>Builder Subtotal</td>
				<td className="cost" colSpan={1}><span className="readOnly">{ util.formatAsCurrency(summary.orderNetPrice + summary.builderUpgradeSellPrice) }</span></td>
				<td />
				<td />
			</tr>
			<tr>
				<td />
				<td className="cost" colSpan={7}>GST</td>
				<td className="cost" colSpan={1}><span className="readOnly">{ util.formatAsCurrency(summary.orderTaxesAndFees) }</span></td>
				<td />
				<td />
			</tr>
			<tr>
				<td />
				<td className="cost" colSpan={7}>Builder Total</td>
				<td className="cost" colSpan={1}><span className="readOnly">{ util.formatAsCurrency(summary.orderTotalPrice) }</span></td>
				<td />
				<td />
			</tr>
		</tfoot>);
	}
};

const JobCostUpgradeSection = jobCostRowOwner({ listAccessor: model => model.lineItems, listFilterThunkFactory: props => row => row.type === props.type }, class UpgradesSection extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.state = this.getStateFromProps(props);
		this.handleChargeAllClick = this.handleChargeAllClick.bind(this);
		this.dropLineItem = this.dropLineItem.bind(this);
	}

	getStateFromProps (props) {
		const state = _.assign({}, this.state);

		if (!state.pendingLineItem || state.pendingLineItem.type !== props.type) {
			state.pendingLineItem = this.createPendingLineItem(props);
		}

		return state;
	}

	addLineItemHandler (lineItemKey, isValid) {
		if (!isValid) {
			return;
		}

		this.props.updateModel(model => {
			if (lineItemKey === this.state.pendingLineItem.key) {
				this.state.pendingLineItem.sortIndex = this.props.getNextSortIndex(model);
				model.lineItems.set(lineItemKey, this.state.pendingLineItem);

				this.props.sortRows(model);

				this.setState({ pendingLineItem: this.createPendingLineItem(this.props) });
			}
		}, { autoSave: true });
	}

	createPendingLineItem (props) {
		const { jobCost, type } = props;

		return jobCost.createLineItem({ type: type, margin: 1, cost: 0 });
	}

	updateModel (key, updater, options) {
		this.props.updateModel((jobCost, lineUpdateCallback) => {
			let lineItem = jobCost.lineItems.get(key);

			if ((!lineItem) && (key === this.state.pendingLineItem.key)) {
				lineItem = this.state.pendingLineItem;
				options.autoSave = false;
			}

			if (lineItem) {
				updater(lineItem, lineUpdateCallback);
			}
		}, options);
	}

	dropLineItem (sourceKey, targetKey) {
		this.props.updateModel(jobCost => {
			const sourceItem = jobCost.lineItems.get(sourceKey);
			const targetItem = jobCost.lineItems.get(targetKey);

			this.props.handleItemDrop(jobCost, sourceItem, targetItem);
		}, { autoSave: true });
	}

	handleChargeAllClick () {
		this.props.updateModel((jobCost, lineUpdateCallback) => {
			for (const lineItem of jobCost.getLineItemsByType('client-upgrade')) {
				lineItem.isChargedToBuilder = true;
				lineUpdateCallback(lineItem, '/isChargedToBuilder');
			}
		}, { autoSave: true });
	}

	render () {
		//<!-- Applying the class "dropTarget" to any TR will turn the bottom border color green to indicate that is where a row being dragged will be dropped -->
		const { getRowClasses, jobCost, summary, type, rowContextMenuHandler, updateModel, ...childProps } = this.props;
		const headerActions = type === 'client-upgrade' ? [<button onClick={ this.handleChargeAllClick }><span>Charge All to Builder</span></button>] : [];

		const lineItems = _.map(_.sortBy(jobCost.getLineItemsByType(type), 'sortIndex'), item => {
			return (
				<JobCostUpgradeRow key={item.rowKey} updateModel={this.updateModel.bind(this, item.key)} dropLineItem={ this.dropLineItem } buttonHandler={ rowContextMenuHandler.bind(this, item)} lineItem={item} classNames={ getRowClasses({ item: item }) } buttonClass="icon iconOnly contextMenu" draggable={true} workAreas={ jobCost.workAreas } alwaysValidate={ true } {...childProps}/>
			);
		});

		return (<section>
			<Header title={_.startCase(type) + 's'} actions={ headerActions } />
			<div>
				<div className="inner">
					<table className="compact draggable" cellPadding="0" cellSpacing="0">
						<JobCostUpgradeHead type={type} />
						<tbody>
							<JobCostHiddenWhenLocked jobCost={ jobCost }><JobCostUpgradeRow key={this.state.pendingLineItem.key} updateModel={this.updateModel.bind(this, this.state.pendingLineItem.key)} buttonHandler={this.addLineItemHandler.bind(this, this.state.pendingLineItem.key)} lineItem={this.state.pendingLineItem} buttonClass="icon iconOnly addItem" draggable={false} workAreas={ jobCost.workAreas } {...childProps}/></JobCostHiddenWhenLocked>
							{ lineItems }
						</tbody>
						<JobCostUpgradeFoot jobCost={ jobCost } summary={ summary } type={ type } />
					</table>
				</div>
			</div>
		</section>);
	}
});

const BUILDER_MODEL_NAME_SETTING_KEY = 'builderModelName';
export default class JobCostEditUpgrades extends React.Component<any,any> {
	constructor (props) {
		super(props);
	}

	printReport (type) {
		const { fetchReport } = this.props;

		return fetchReport(`contract/${type}`);
	}

	updateSetting (name, autoSave, e) {
		e.preventDefault();

		const newVal = (autoSave) ? valueFilters.clean(e.target.value) : e.target.value;

		this.props.updateModel((model, childUpdateCallback) => {
			const setting = model.setSetting(enums.jobCostSettingGroups.General, name, undefined, newVal);

			if (setting) {
				childUpdateCallback(setting);
			}
		}, { autoSave: autoSave, updatePath: 'settings' });
	}

	render () {
		const { store } = componentServices;
		const { jobCost, summary, updateModel } = this.props;
		const job = jobCost.jobKey ? getModel({ store, collection: ModelCollection.jobs, key: jobCost.jobKey }) : null;
		const builder = job && job.builderKey && getModel({ store, collection: ModelCollection.contractors, key: job.builderKey });
		const modelName = jobCost.getSettingValue(enums.jobCostSettingGroups.General, BUILDER_MODEL_NAME_SETTING_KEY, undefined, '');

		const sections = _.map(_jobCostLineItemTypes, type => {
			let upgrades = [];

			if (builder) {
				const upgradeType = type === 'builder-upgrade' ? enums.contractorUpgradeTypes.Builder : enums.contractorUpgradeTypes.Client;

				upgrades = _.sortBy(_.filter(builder.upgrades, { upgradeType }), 'description');
			}

			return (
				<JobCostUpgradeSection key={type} upgrades={ upgrades } updateModel={updateModel} jobCost={ jobCost } summary={ summary } type={type} />
			);
		});

		return (
			<section>
				<Header title="Upgrades"/>
				<div className="jobCostUpgrades">
					<div className="inner">
						<table className="compact" cellPadding="0" cellSpacing="0">
							<tbody>
								<JobCostLockable jobCost={ jobCost }>{ ({ getClassName }) =>
									(<tr className={ getClassName() }>
										<td />
										<td className="modelProperty"><span className="readOnly">Model Name</span></td>
										<td className="description"><input type="text" value={ modelName } onChange={ this.updateSetting.bind(this, BUILDER_MODEL_NAME_SETTING_KEY, false) } onBlur={ this.updateSetting.bind(this, BUILDER_MODEL_NAME_SETTING_KEY, true) } /></td>
										<td />
									</tr>)
								}
								</JobCostLockable>
							</tbody>
						</table>
					</div>
					{sections}
				</div>
			</section>
		);
	}
}